import React from 'react'
import { useApp } from '../../context/AppContext'
import type { TaxCard as TaxCardData } from '../../types/app'
import { estimate, money, share } from './format'
import { Icon } from '../../ui/Icon'

interface Props {
  tax: TaxCardData
  onChanged: () => void
}

// TaxCard is the Earnings screen's tax reserve estimate. Where she pays tax
// is asked in one place, Your business (design review P4); until she has
// said, this points there and refreshes when she comes back.
export default function TaxCard({ tax, onChanged }: Props) {
  const { state, dispatch } = useApp()
  const asked = React.useRef(false)
  React.useEffect(() => {
    if (asked.current && state.settingsPanel === null) {
      asked.current = false
      onChanged()
    }
  }, [state.settingsPanel, onChanged])

  if (tax.needs_region) {
    return (
      <div className="goal-card tax-card">
        <span className="goal-label">Set aside for tax</span>
        <p className="goals-muted">Say where you pay tax and this shows what to put aside each month.</p>
        <button
          type="button"
          className="btn btn-secondary btn-compact"
          onClick={() => {
            asked.current = true
            dispatch({ type: 'OPEN_SETTINGS_PANEL', payload: 'business' })
          }}
        >
          Set it in Settings → Your business <Icon name="chevron-right" size={16} />
        </button>
      </div>
    )
  }

  return (
    <div className="goal-card tax-card">
      <span className="goal-label">Set aside {money(tax.set_aside_month_pence)} this month</span>
      <p className="tax-card__line">
        {money(tax.set_aside_ytd_pence)} so far this tax year{tax.tax_year_label ? ` (${tax.tax_year_label})` : ''}
      </p>
      <p className="tax-card__line">About {share(tax.rate_bp)} of your take-home</p>
      <p className="tax-card__line">Based on about {estimate(tax.projected_pence)} take-home this tax year</p>
      {tax.imported_takings_pence > 0 && (
        <p className="tax-card__line">
          Includes {money(tax.imported_takings_pence)} from your Fresha visits since 6 April, before their costs, to estimate your rate.
        </p>
      )}
      {tax.rates_year_label && <p className="tax-card__line">using {tax.rates_year_label} rates</p>}
      <p className="tax-card__note">
        {tax.imported_takings_pence > 0
          ? 'An estimate from your take-home in Harmovi and your Fresha visits since 6 April (before their costs). Guidance, not tax advice.'
          : 'An estimate from your take-home in Harmovi. Guidance, not tax advice.'}
      </p>
    </div>
  )
}
